import { render } from "./EventUserForm.vue?vue&type=template&id=2f01c518&lang=pug"
import script from "./EventUserForm.vue?vue&type=script&lang=js"
export * from "./EventUserForm.vue?vue&type=script&lang=js"

import exportComponent from "/builds/mfar.technology/events/events-platform/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__